import { BaseContainerModel } from '../../base-container.model';
import { bl_cms_post_image_RowClass } from '../../../dbschema/bl_cms_post_image.model';

export class CmsPostImageContainerModel extends BaseContainerModel {
  bl_cms_post_image: bl_cms_post_image_RowClass = new bl_cms_post_image_RowClass();
}
